// extracted by mini-css-extract-plugin
export default {"pageLayout":"mb-z","mainContent":"nb-z","columnLayout":"ob-z","columnLayoutFill":"pb-z","columnLayoutLast":"qb-z"};